import { WarningOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

import { CloseIconsForModalWithDataTestId } from '@app/components/CloseIconsForModalWithDataTestId';

import type { FC } from 'react';

interface ConfirmModalProps {
  open: boolean;
  title?: string | JSX.Element;
  message?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  discardText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onDiscard: () => void;
  showDiscard?: boolean;
  dataTestId?: string;
}
export const ConfirmModal: FC<ConfirmModalProps> = ({
  open,
  title = 'Подтверждение',
  message,
  confirmText = 'Сохранить и уйти',
  cancelText = 'Отмена',
  discardText,
  onConfirm,
  onCancel,
  onDiscard,
  showDiscard,
  dataTestId = '',
}) => (
  <Modal
    open={open}
    onCancel={onCancel}
    centered
    zIndex={10_000}
    getContainer={false}
    data-testid={dataTestId}
    title={
      <span data-testid="unsaved-changes-popup-title">
        <WarningOutlined style={{ color: 'orange', marginRight: 8 }} />
        {title}
      </span>
    }
    closeIcon={<CloseIconsForModalWithDataTestId />}
    footer={[
      <Button key="cancel" onClick={onCancel} data-testid="cancel-changes">
        {cancelText || 'Отмена'}
      </Button>,
      ...[
        ...(showDiscard && !!discardText
          ? [
              <Button
                key="discard"
                danger
                onClick={onDiscard}
                data-testid="leave-without-changes"
              >
                {discardText}
              </Button>,
            ]
          : []),
      ],
      <Button
        key="confirm"
        type="primary"
        onClick={onConfirm}
        data-testid="save-changes"
      >
        {confirmText || 'Сохранить'}
      </Button>,
    ]}
  >
    {message && <p data-testid="alert_text">{message}</p>}
  </Modal>
);
